/**
 * @license
 *
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import settings from 'carbon-components/es/globals/js/settings';
import { customElement, LitElement } from 'lit-element';
import styles from './side-nav.scss';

const { prefix } = settings;

/**
 * A divider in side nav.
 * @element bx-side-nav-divider
 */
@customElement(`${prefix}-side-nav-divider`)
class BXSideNavDivider extends LitElement {
  connectedCallback() {
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'separator');
    }
    super.connectedCallback();
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

export default BXSideNavDivider;
